import {Component, inject} from '@angular/core'
import {RouterOutlet} from '@angular/router'
import version from '../assets/package.json'
import {HeaderComponent} from './common/header/header.component'
import {PdfViewerComponent} from './common/pdf-viewer/pdf-viewer.component'
import {ConfigService} from './services/config.service'

@Component({
  selector: 'spb-root',
  templateUrl: './app.component.html',
  styleUrl: 'app.component.scss',
  imports: [
    RouterOutlet,
    HeaderComponent,
    PdfViewerComponent
  ]
})
export class AppComponent {
  public version = version.version
  public configService = inject(ConfigService)
}
